<template>
  <div class="full-height">
    <v-card width="100%" rounded="0" class="full-height whistle-gradient">
      <v-row class="mt-0 mx-0">
        <v-col cols="12" sm="12" md="4" lg="3" xl="3" :class="{ 'pl-6 pr-0': !isMobile }">
          <div
            v-if="!magicLinkToken && isRecognitionsEnabled()"
            class="white--text d-flex justify-start full-width align-center pt-2 recognition-recommendation cursor-pointer"
            :class="{ 'mt-5': isMobile, 'mt-16': !isMobile }"
            @click="loadRecognition"
          >
            <div class="recognition-emoji-outer-circle">
              <div class="recognition-emoji-inner-circle">
                <v-icon color="white" large class="pb-0 mb-0 1recognition-emoji"
                  >mdi-party-popper</v-icon
                >
              </div>
            </div>
            <p class="pb-0 mb-0 ml-3">Recognize someone</p>
          </div>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="9" xl="9" :class="{ 'message-feed': !isMobile }">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="10" lg="9" xl="8" :class="isMobile ? 'pt-0 px-0' : ''">
              <div
                class="d-flex full-width justify-space-between align-center white--text text-left mb-4"
                :class="{
                  'px-12': $vuetify.breakpoint.lg || $vuetify.breakpoint.xl,
                }"
              >
                <h2 class="font-weight-bold word-break">Activity</h2>
                <v-btn
                  v-if="devEnvironment"
                  @click="display.debug = !display.debug"
                  depressed
                  text
                  color="white"
                  class="white--text"
                  ><v-icon>mdi-bug</v-icon>Debug (Dev)</v-btn
                >
                <v-menu v-model="display.filterMenu" offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn depressed text color="white" class="white--text" v-bind="attrs" v-on="on"
                      ><v-icon>mdi-filter</v-icon>Filters</v-btn
                    >
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.wallet"
                          @change="filterActivity()"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="text-left">
                        <v-list-item-title>Wallet</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn text small color="brandCyan" @click="loadOneFilter('wallet')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.recognition_recipient"
                          @change="filterActivity('recognition_recipient')"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="text-left">
                        <v-list-item-title>My Recognitions</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn
                          text
                          small
                          color="brandCyan"
                          @click="loadOneFilter('recognition_recipient')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.recognition"
                          @change="filterActivity('recognition')"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="text-left">
                        <v-list-item-title>All Recognitions</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn text small color="brandCyan" @click="loadOneFilter('recognition')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.program"
                          @change="filterActivity('program')"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="text-left">
                        <v-list-item-title>Program</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn text small color="brandCyan" @click="loadOneFilter('program')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.news"
                          @change="filterActivity('news')"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="text-left">
                        <v-list-item-title>News</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn text small color="brandCyan" @click="loadOneFilter('news')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.general"
                          @change="filterActivity('general')"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content class="text-left">
                        <v-list-item-title>General</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn text small color="brandCyan" @click="loadOneFilter('general')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox
                          color="brandCyan"
                          :true-value="true"
                          :false-value="false"
                          v-model="filters.alerts"
                          @change="filterActivity('alerts')"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>Alerts</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        ><v-btn text small color="brandCyan" @click="loadOneFilter('alerts')"
                          >Only</v-btn
                        ></v-list-item-action
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div
                class="d-flex flex-column justify-center white--text pt-3"
                v-if="loadingActivity"
              >
                <h3>Loading your activity...</h3>
                <div class="mx-auto pt-3">
                  <v-progress-circular
                    indeterminate
                    size="40"
                    :width="3"
                    color="white"
                    class="mr-1"
                  ></v-progress-circular>
                </div>
              </div>
              <div v-else-if="!loadingActivity && !messages.length" class="mt-3 white--text">
                <b
                  class="word-break"
                  v-if="
                    !filters.program &&
                    !filters.news &&
                    !filters.general &&
                    !filters.wallet &&
                    !filters.recognition &&
                    !filters.recognition_recipient &&
                    !filters.alerts
                  "
                  >Select one of the filters to view your activity
                </b>
                <b class="word-break" v-else
                  >Looks like there isn't much activity for you right now. Check back later for
                  more!
                </b>
              </div>
              <v-container
                v-else
                class="full-width d-flex flex-wrap flex-column"
                :class="{
                  'px-12': $vuetify.breakpoint.xl || $vuetify.breakpoint.lg,
                  'px-0': isMobile,
                }"
              >
                <div v-if="display.debug" class="white--text">
                  (Total Records: {{ this.messageOptions.count }}) (Total in Memory:
                  {{ computedVisibleMessages.length }})
                  {{ backgroundActivityRefresh ? "Bkgrnd Task" : "" }}
                  <v-text-field
                    v-model="backgroundRefreshTimeout"
                    type="number"
                    color="white"
                    label="Timeout (ms)"
                  />
                </div>
                <v-progress-linear
                  v-if="refreshingActivity && messages.length > 0"
                  indeterminate
                  color="white"
                  class="mb-2"
                ></v-progress-linear>

                <div class="d-flex flex-column card-column-old full-width">
                  <div
                    v-for="msg in computedVisibleMessages"
                    :key="msg.messageLogId"
                    class="mb-3 activity-card"
                  >
                    <ActivityFeedCard
                      :key="msg.messageLogId"
                      :id="msg.contextResourceId"
                      :messageId="msg.messageId"
                      :icon="msg.icon"
                      :iconColor="msg.iconColor"
                      :context="msg.context"
                      :subcontext="msg.subcontext"
                      :title="msg.cardTitle"
                      :date="msg.date"
                      :messageTitle="msg.messageSubject"
                      :messageSubtitle="msg.messageShortBody"
                      :messageBody="msg.messageBody"
                      :messageSuccessImage="msg.successImage"
                      :image="msg.imageURL"
                      :linkText="msg.linkText"
                      :object="msg"
                      :messageTitleFlag="msg.titleFlag"
                      :messageSubtitleFlag="msg.subtitleFlag"
                      :messageIconFlag="msg.messageIconFlag"
                      :robinFlag="false"
                      :imageFlag="msg.displayImageInCardPreview"
                      :progressFlag="msg.progressFlag"
                      :likedByUser="msg.likedByUser"
                      :linkButtonFlag="true"
                      :fullMessage="msg.context == 'recognition'"
                      :comments="msg.comments"
                      :reactions="msg.reactions"
                      :values="msg.values"
                      :recipients="msg.recipients"
                      :privateRecognition="msg.privateRecognition"
                      :newMessage="!msg.readOnDashboard"
                      :commentsReactionsEnabled="msg.commentsReactionsEnabled"
                      @create-comment="createMessageComment($event, false)"
                      @remove-comment="removeMessageComment($event, msg.messageId, false)"
                      @create-reaction="createMessageReaction(msg.messageId, $event, false)"
                      @remove-reaction="removeMessageReaction(msg.messageId, $event, false)"
                    />
                  </div>
                </div>

                <div class="d-flex full-width justify-center">
                  <v-btn
                    v-if="showMoreButton == true"
                    text
                    color="darkGray"
                    class="mt-4 darkGray--text"
                    @click="loadMoreMessages"
                    :disabled="displayLoadingSpinner"
                  >
                    <v-icon class="mr-1" v-if="displayLoadingSpinner == false">mdi-plus</v-icon>
                    <v-progress-circular
                      v-else
                      indeterminate
                      size="20"
                      :width="3"
                      color="darkGray"
                      class="mr-1"
                    ></v-progress-circular>
                    View More
                  </v-btn>
                </div>
              </v-container></v-col
            >
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="devError" width="400">
      <v-card class="py-6">
        Error hitting an endpoint while running the {{ devErrorType }} function.
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="displayPopup"
      width="600"
      persistent
      content-class="elevation-0 mx-3 px-0 recognition-popup-dialog"
      class=""
    >
      <div class="d-flex align-center justify-center px-1 full-height">
        <div class="d-flex flex-column align-center full-height">
          <div class="d-flex justify-space-between align-center full-width mb-5">
            <v-btn
              fab
              small
              class="elevation-0 hidden"
              color="grey"
              @click="dismissMessage(currentPopup.messageLogId, true, false, false)"
              ><v-icon color="white" dark>mdi-close</v-icon></v-btn
            >
            <div class="d-flex align-center">
              <v-btn
                icon
                small
                :class="{
                  hidden: currentPopupIndex == 0 || displaySingleMessage,
                }"
                class="mr-1"
                @click="dismissMessage(currentPopup.messageLogId, false, true, false)"
                ><v-icon color="white" x-large>mdi-chevron-left</v-icon></v-btn
              >
              <div
                class="white-background pl-2 pr-3 py-1 rounded d-flex align-center"
                v-if="popups.length > 1 || $vuetify.breakpoint.xs"
              >
                <h3 class="black--text text-lg font-italic mx-1 mt-1">
                  {{ currentPopupIndex + 1 }} of {{ popups.length }}
                </h3>
              </div>
              <v-btn
                icon
                small
                :class="{
                  hidden: currentPopupIndex >= popups.length - 1 || displaySingleMessage,
                }"
                class="ml-1"
                @click="dismissMessage(currentPopup.messageLogId, false, false, true)"
                ><v-icon color="white" x-large>mdi-chevron-right</v-icon></v-btn
              >
            </div>
            <v-btn
              fab
              x-small
              class="elevation-0"
              color="grey"
              @click="dismissMessage(currentPopup.messageLogId, true, false, false)"
              ><v-icon color="white" dark>mdi-close</v-icon></v-btn
            >
          </div>
          <ActivityFeedCard
            v-if="currentPopup"
            :elevation="0"
            width="400"
            maxWidth="calc(100vw - 40px)"
            :key="currentPopup.messageLogId"
            :id="currentPopup.contextResourceId"
            :messageId="currentPopup.messageId"
            :icon="currentPopup.icon"
            :iconColor="currentPopup.iconColor"
            :context="currentPopup.context"
            :subcontext="currentPopup.subcontext"
            :title="currentPopup.cardTitle"
            :date="currentPopup.date"
            :messageTitle="currentPopup.messageSubject"
            :messageSubtitle="currentPopup.messageShortBody"
            :messageBody="currentPopup.messageBody"
            :messageSuccessImage="currentPopup.successImage"
            :image="currentPopup.imageURL"
            :linkText="currentPopup.linkText"
            :object="currentPopup"
            :messageTitleFlag="currentPopup.titleFlag"
            :messageSubtitleFlag="currentPopup.subtitleFlag"
            :messageIconFlag="currentPopup.messageIconFlag"
            :robinFlag="false"
            :imageFlag="currentPopup.displayImageInCardPreview"
            :likedByUser="currentPopup.likedByUser"
            :linkButtonFlag="true"
            :popup="true"
            :fullMessage="currentPopup.context == 'recognition'"
            :comments="currentPopup.comments"
            :reactions="currentPopup.reactions"
            :values="currentPopup.values"
            :celebration="currentPopup.celebrationEffect"
            :recipients="currentPopup.recipients"
            :privateRecognition="currentPopup.privateRecognition"
            :commentsReactionsEnabled="currentPopup.commentsReactionsEnabled"
            @create-comment="createMessageComment($event, true)"
            @remove-comment="removeMessageComment($event, currentPopup.messageId, true)"
            @create-reaction="createMessageReaction(currentPopup.messageId, $event, true)"
            @remove-reaction="removeMessageReaction(currentPopup.messageId, $event, true)"
            :class="{
              'card-stack': popups.length > 1 && popups.length <= 2,
              'card-stack-multiple': popups.length > 2,
            }"
          />
        </div></div
    ></v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import CommunicationService from "@/services/CommunicationService.js";
import CommunicationServiceV2 from "@/services/CommunicationServiceV2";
import ActivityFeedCard from "@/components/activity/ActivityFeedCardV2.vue";
import { mapState } from "vuex";
import momentTz from "moment-timezone";
import isRecognitionsEnabled from "@/mixins/isRecognitionsEnabled";

export default {
  name: "Activity",
  title: "Activity",
  mixins: [isRecognitionsEnabled],
  props: {
    messageId: {
      type: String,
    },
  },
  components: {
    ActivityFeedCard,
  },
  data() {
    return {
      communicationService: null,
      backgroundRefreshTimeout: 30000,
      loadingActivity: true,
      backgroundActivityRefresh: false,
      search: null,
      display: { filters: false, debug: false, filterMenu: false },
      filters: {
        program: true,
        learning: false,
        survey: false,
        wallet: true,
        recognition: true,
        recognition_recipient: false,
        news: true,
        general: true,
        robin: false,
        alerts: true,
      },
      refreshingActivity: false,
      messages: [],
      popups: [],
      maxPopupId: null,
      activityPageSize: 20,
      openMessage: null,
      refreshTimeout: null,
      lastPopupRefresh: null,
      lastActivityRefresh: null,
      messageOptions: {
        filter: null,
        page: 1,
        total: 0,
        count: 0,
      },
      displayLoadingSpinner: false,
      devError: false,
      devErrorType: null,
      currentPopupIndex: null,
      displayPopup: false,
      displaySingleMessage: false,
      singleMessage: null,
    };
  },
  created() {
    this.communicationService = new CommunicationServiceV2();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onScreenResize);
    });
    this.getActivity(true, true);
    if (this.messageId) this.getSpecificActivity(this.messageId);
    else this.getPopupMessages(true);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onScreenResize);
    if (this.refreshTimeout) {
      console.log("Clearing refresh timeout");
      clearTimeout(this.refreshTimeout);
    }
  },
  unmounted() {},
  methods: {
    async getActivity(displayLoading = true, reset = false, refresh = false) {
      console.log("getActivity() ", { displayLoading, reset, refresh });
      if (this.computedFilterString == null) {
        this.messages = [];
        return;
      }

      try {
        if (reset == true) this.messageOptions.page = 1;
        // If displayLoading is true it displays the robin icon
        this.loadingActivity = displayLoading;
        this.backgroundActivityRefresh = refresh;
        // Else, we display a loading spinner
        this.displayLoadingSpinner = !displayLoading;
        // let filter = `status != 'Deleted' && clientId=${this.userProfile.clientId}`;
        let page = this.messageOptions.page;
        // We fetch a page ahead. To do this, on page 1 we fetch both page 1 & 2 at the same time. Then we're a page ahead the rest of the time
        let limit = this.activityPageSize; //page == 1 ? 20 : 10;
        let offset = page == 1 || refresh ? 0 : this.messages.length; //(page - 1) * limit;
        let currentContexts = this.computedFilterString;
        console.log({
          // filter: filter,
          limit: limit,
          offset: offset,
        });

        let since;
        if (refresh && this.messages.length) {
          since = Math.max(...this.messages.map((x) => x.messageLogId));
        }
        // Immediately overwrite lastActivityRefresh
        this.lastActivityRefresh = momentTz().utc().format("YYYY-MM-DD HH:mm:ss.sssZ");
        const params = {
          since,
          limit: limit,
          offset: offset,
          sort: "sendDate DESC",
          recognition_recipient: this.filters.recognition_recipient //&& this.filters.recognition
            ? 1
            : 0,
          sourceUser: this.userProfile.userId,
        };
        const messages = await this.communicationService.getMessagesV3(
          params,
          this.computedFilterString,
          this.magicLinkToken
        );
        // Ensures that if there are multiple api requests at once, that we're only setting data for the most recent
        const newRecognitionRecipientValue = this.filters.recognition_recipient //&& this.filters.recognition
          ? 1
          : 0;
        if (
          this.computedFilterString !== currentContexts ||
          newRecognitionRecipientValue != params.recognition_recipient
        ) {
          console.log("Ignoring request ", {
            currentContexts,
            displayLoading,
            refresh,
            reset,
            newRecognitionRecipientValue,
          });
          return;
        }
        console.log("Messages ", messages.result);
        let newMessages = [];
        const messageArr = messages.result.rows.map((msg) => {
          msg.date = momentTz(msg.sendDate).local().format("MMM D - h:mm A");
          // .format("YYYY-MM-DD h:mm a");
          return msg;
        });

        if (reset || !refresh) this.messageOptions.count = messages.result.count;

        if (reset) {
          // this.messageOptions.total = messageArr.length;
          this.messages = messageArr;
        } else {
          let numAdded = 0;
          // this.messageOptions.total += messageArr.length;
          messageArr.forEach((item) => {
            const existingMsg = this.messages.find((x) => x.messageLogId == item.messageLogId);
            if (!existingMsg) {
              this.messages.push(item);
              newMessages.push(item);
              numAdded++;
            } else console.log("Not adding message already in array");
          });
          // this.messageOptions.total += numAdded;
          if (refresh) this.messageOptions.count += numAdded;
        }

        this.loadingActivity = false;
        if (refresh) this.backgroundActivityRefresh = false;
        this.displayLoadingSpinner = false;
        this.refreshingActivity = false;

        this.markActivityAsRead(reset ? messageArr : newMessages);
      } catch (error) {
        console.log("error ", error);
        this.loadingActivity = false;
        if (refresh) this.backgroundActivityRefresh = false;
        this.displayLoadingSpinner = false;
      }
    },
    async getPopupMessages(refresh = false) {
      try {
        let since;
        if (refresh && this.popups.length) {
          since = Math.max(...this.popups.map((x) => x.messageLogId));
        } else if (refresh && this.maxPopupId) since = this.maxPopupId;
        // if (refresh && this.popups.length) {
        //   since = Math.max(...this.popups.map(x => x.messageLogId));
        // }
        // Immediately overwrite lastPopupRefresh
        this.lastPopupRefresh = momentTz().utc().format("YYYY-MM-DD HH:mm:ss.sssZ");
        const messages = await this.communicationService.getPopupMessagesV3(
          {
            source: this.userProfile.userId,
            since,
          },
          this.magicLinkToken
        );

        console.log("Popups ", messages);
        let arr = messages.rows.map((msg) => {
          msg.date = momentTz(msg.sendDate).local().format("MMM D - h:mm A");
          return msg;
        });

        if (refresh) {
          arr.forEach((item) => {
            const existingPopup = this.popups.find((x) => x.messageLogId == item.messageLogId);
            if (!existingPopup) this.popups.push(item);
          });
        } else this.popups = arr;

        // Update these values if it's not already open
        if (this.popups.length && !this.displayPopup) {
          this.currentPopupIndex = 0;
          this.displayPopup = true;
        }
      } catch (error) {
        console.log("error getting popup messages ", error);
      } finally {
        this.refreshTimeout = setTimeout(
          () => {
            console.log("Background refresh running");
            this.getPopupMessages(true);
            this.getActivity(false, false, true);
          },
          this.backgroundRefreshTimeout < 500 ? 500 : this.backgroundRefreshTimeout
        );
      }
    },
    async getSpecificActivity(messageId) {
      if (!messageId) return;
      console.log("getSpecificActivity() ", { messageId });
      try {
        const messages = await CommunicationService.getMessageV2(messageId, this.magicLinkToken);

        console.log("Loading specific msg ", messages.data.result);
        const messageArr = messages.data.result.rows.map((msg) => {
          msg.date = momentTz(msg.sendDate).local().format("MMM D - h:mm A");
          return msg;
        });

        messageArr.forEach((item) => {
          this.singleMessage = item;
          this.displayPopup = true;
          this.displaySingleMessage = true;
        });

        if (!this.singleMessage) throw 404;
      } catch (error) {
        console.log("error loading single message ", error);
        // Reset and fetch popups like normal since we had an error
        this.getPopupMessages(true);

        // Show snackbar
        this.$store.dispatch("showError", {
          message: "We had trouble finding the activity message.",
        });
      }
    },
    async markActivityAsRead(messages = []) {
      try {
        const readMessages = messages.filter((x) => !x.readOnDashboard).map((x) => x.messageLogId);
        if (!readMessages.length) return;
        console.log("We need to mark messages as read ", readMessages);
        const readResponse = await CommunicationService.updateMessageLogAsReadV2(
          readMessages,
          undefined,
          this.magicLinkToken
        );
        console.log("Marked messages as read ", readResponse);

        // Now refresh the unread count
        this.$store.dispatch("setUnreadMessages");
      } catch (e) {
        console.log("Error marking messages as read ", e);
      }
    },
    filterActivity(type) {
      if (type == "recognition_recipient") {
        this.filters.recognition = false;
      } else if (type == "recognition") {
        this.filters.recognition_recipient = false;
      }
      this.refreshingActivity = true;

      this.getActivity(false, true);
    },
    loadOneFilter(type) {
      Object.keys(this.filters).forEach((context) => {
        if (type != context) this.filters[context] = false;
        else this.filters[context] = true;
      });

      this.refreshingActivity = true;
      this.getActivity(false, true);
    },
    loadMoreMessages() {
      this.messageOptions.page = this.messageOptions.page + 1;
      this.getActivity(false, false);
    },
    loadRecognition() {
      this.$router.push({
        name: "recognitionwizard",
        params: {
          previousRoute: this.$route.name,
        },
      });
    },
    async createMessageComment(obj, popup) {
      console.log("Create message comment", obj);

      try {
        let comment = await CommunicationService.createMessageComment(
          {
            messageId: obj.messageId,
            comment: obj.comment,
          },
          this.magicLinkToken
        );
        // console.log("Created comment response ", { comment });
        if (obj.callback && comment[0]) obj.callback(comment[0]);
        if (popup) {
          const index = this.messages.findIndex((x) => x.messageId == obj.messageId);
          if (index !== -1) {
            if (!this.messages[index].comments) this.messages[index].comments = [];
            this.messages[index].comments.push({
              ...comment[0],
              name: `${this.userProfile.firstName} ${this.userProfile.lastName}`,
            });
          }
        }
      } catch (e) {
        console.log("error creating comment ", e);
        if (this.devEnvironment) {
          this.devError = true;
          this.devErrorType = "createMessageComment";
        }
        obj.callback();
      }
    },
    async removeMessageComment(commentId, messageId, popup) {
      try {
        await CommunicationService.deleteMessageComment(commentId, this.magicLinkToken);
        if (popup) {
          const index = this.messages.findIndex((x) => x.messageId == messageId);
          if (index !== -1) {
            const commentIndex = (this.messages[index].comments || []).findIndex(
              (x) => x.messageCommentId == commentId
            );
            if (commentIndex !== -1) this.messages[index].comments.splice(commentIndex, 1);
          }
        }
      } catch (e) {
        console.log("error deleting comment ", e);
        if (this.devEnvironment) {
          this.devError = true;
          this.devErrorType = "removeMessageComment";
        }
      }
    },
    async createMessageReaction(messageId, emoji, popup) {
      try {
        await CommunicationService.createMessageReaction(
          {
            messageId,
            reaction: emoji,
          },
          this.magicLinkToken
        );
        if (popup) {
          const index = this.messages.findIndex((x) => x.messageId == messageId);
          if (index !== -1) {
            let existingEmoji = this.messages[index].reactions.find((x) => x.emoji == emoji);
            if (existingEmoji && !existingEmoji.hasLiked) {
              existingEmoji.count = existingEmoji.count + 1;
              existingEmoji.hasLiked = true;
            } else if (!existingEmoji) {
              this.messages[index].reactions.push({
                emoji,
                count: 1,
                hasLiked: true,
              });
            }
          }
        }
      } catch (e) {
        console.log("error creating reaction ", e);
        if (this.devEnvironment) {
          this.devError = true;
          this.devErrorType = "createMessageReaction";
        }
      }
    },
    async removeMessageReaction(messageId, emoji, popup) {
      try {
        await CommunicationService.removeMessageReaction(
          messageId,
          {
            reaction: emoji,
          },
          this.magicLinkToken
        );

        if (popup) {
          const index = this.messages.findIndex((x) => x.messageId == messageId);
          if (index !== -1) {
            let existingEmoji = this.messages[index].reactions.find((x) => x.emoji == emoji);
            if (existingEmoji) {
              existingEmoji.count--;
              existingEmoji.hasLiked = false;
            }
          }
        }
      } catch (e) {
        console.log("error removing reaction ", e);
        if (this.devEnvironment) {
          this.devError = true;
          this.devErrorType = "removeMessageReaction";
        }
      }
    },
    async dismissMessage(messageLogId, close = false, back = false, next = false) {
      try {
        console.log("Dismissing message", { messageLogId, close, back, next });
        if (close && this.singleMessage) {
          // Exception to the rule - we haven't gotten popups yet so we just close, reset, and get popups
          this.displayPopup = false;
          this.displaySingleMessage = false;
          this.singleMessage = null;
          this.getPopupMessages(true);
          return;
        }
        CommunicationService.updatePopupMessageAsRead(messageLogId, this.magicLinkToken);
        if (close) {
          this.displayPopup = false;
          this.maxPopupId = this.popups.length
            ? Math.max(...this.popups.map((x) => x.messageLogId))
            : null;
          this.popups = [];
          this.currentPopupIndex = null;
        } else if (back) this.currentPopupIndex--;
        else if (next) this.currentPopupIndex++;
      } catch (e) {
        console.log("error dismissing ", e);
        if (this.devEnvironment) {
          this.devError = true;
          this.devErrorType = "dismissMessage";
        }
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "postItArray", "activity", "magicLinkToken"]),
    devEnvironment() {
      return !!(
        process.env.VUE_APP_ENVIRONMENT == "dev" || process.env.VUE_APP_ENVIRONMENT == "test"
      );
    },
    computedVisibleMessages() {
      // Used to sort messages and slice based on how many they're viewing at once
      var messages = this.messages;
      messages.sort(function (a, b) {
        return momentTz(a.sendDate).isAfter(momentTz(b.sendDate)) ? -1 : 1;
      });

      messages = messages.filter(
        (m) =>
          this.filters[m.context] == true ||
          (this.filters.recognition_recipient && m.context == "recognition")
      );

      return messages;
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    showMoreButton() {
      // console.log("Current count ", this.messageOptions.count);
      // console.log("Current total ", this.messageOptions.total);
      return (
        this.messageOptions.count > this.computedVisibleMessages.length &&
        (this.filters.program ||
          this.filters.news ||
          this.filters.general ||
          this.filters.wallet ||
          this.filters.recognition ||
          this.filters.recognition_recipient ||
          this.filters.alerts)
      );
    },
    computedFilterString() {
      let string = [];
      if (this.filters.program == true && this.displayProgramFilterButton) string.push("program");
      // if (this.filters.survey == true && this.displayProgramFilterButton)
      // string.push("surveys");
      if (this.filters.wallet == true && this.displayWalletFilterButton) string.push("wallet");
      if (this.filters.recognition == true) string.push("recognition");
      if (this.filters.recognition_recipient == true) string.push("recognition_recipient");
      if (this.filters.news == true) string.push("news");
      if (this.filters.general == true) string.push("general");
      if (this.filters.alerts == true) string.push("alerts");

      if (string.length > 0) return string.join();
      else return null;
    },
    displayWalletFilterButton() {
      if (this.userProfile && this.userProfile.Client)
        return this.userProfile.Client.displayWalletPage;
      return true;
    },
    displayProgramFilterButton() {
      if (this.userProfile && this.userProfile.Client)
        return this.userProfile.Client.displayProgramPage;
      return true;
    },
    currentPopup() {
      if (this.displaySingleMessage && this.singleMessage) return this.singleMessage;
      if (this.currentPopupIndex == null) return null;
      return this.popups[this.currentPopupIndex];
    },
  },
};
</script>

<style scoped>
.button-text {
  font-size: 20px;
}
.card-column {
  min-width: 290px;
  width: 33%;
  max-width: 350px;
}
.brand-background {
  background-color: var(--v-brand-base);
}
.brand-dark-green-background {
  background-color: var(--v-brandDarkGreen-base);
}
.error-background {
  background-color: var(--v-error-base);
}
.brand-yellow-background {
  background-color: var(--v-brandYellow-base);
}
.light-grey-background {
  background-color: var(--v-lightGrey-base);
}
.grey-background {
  background-color: var(--v-grey-base);
}
.medium-grey-background {
  background-color: var(--v-mediumGrey-base);
}
.border-radius {
  border-radius: 5px;
}

/* making cards full width mobile & tablets */
@media only screen and (max-width: 800px) {
  .card-column {
    width: 100%;
    max-width: 100%;
  }
}

.outlined-bottom {
  border-bottom: 1px solid;
  /* border-width: 1px 1px 0px 0px; */
  border-color: var(--v-grey-base);
}

.outlined-top {
  border-top: 1px solid;
  /* border-width: 1px 1px 0px 0px; */
  border-color: var(--v-grey-base);
}

.whistle-gradient {
  background: rgb(161, 215, 110);
  background: linear-gradient(0deg, white 5%, #09acec 60%, #065c9e 100%);
}

.admin-button {
  color: #09acec;
}

.full-card-width {
  width: calc(100% - 32px);
}

.progress-bar {
  width: calc(100% - 40px);
}

.progress-bar-bump {
  margin-top: 9px;
}

.card-stack {
  /* box-shadow: 10px 5px 2px white; */
  border-radius: 3px;
  box-shadow:
    /* The top layer shadow */ 2px -2px 1px rgba(0, 0, 0, 0.15),
    /* The second layer */ 8px -6px 0 0 #eee,
    /* The second layer shadow */ 10px -8px 1px rgba(0, 0, 0, 0.15) !important;
  /* Padding for demo purposes */
  /* padding: 30px; */
}

.card-stack-multiple {
  /* box-shadow: 10px 5px 2px white; */
  border-radius: 3px;
  box-shadow:
    /* The top layer shadow */ 2px -2px 1px rgba(0, 0, 0, 0.15),
    /* The second layer */ 8px -6px 0 0 #eee,
    /* The second layer shadow */ 10px -8px 1px rgba(0, 0, 0, 0.15),
    /* The third layer */ 16px -12px 0 0 #eee !important;
  /* Padding for demo purposes */
  /* padding: 30px; */
}

/* elevation-3
 box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12)

    */

/* .height-100 {
  height: 100%;
} */

.recognition-recommendation {
  font-size: large;
  font-weight: bold;
}

.recognition-emoji {
  font-size: 35px;
}

.recognition-emoji-inner-circle {
  background: var(--v-brandCyan-base);
  border-radius: 50%;
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.recognition-emoji-outer-circle {
  background: var(--v-brandLightCyan-base);
  border-radius: 50%;
  width: 61px;
  height: 61px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.2), 0 1px 15px 0 rgba(0, 0, 0, 0.19) !important;
}
.message-feed {
  /* Grow with the cards so the window scrolls. A viewport height ignores the
     app bar and the announcement banner and leaves the page a little taller
     than the window. */
  overflow-anchor: none;
}

/* ::-webkit-scrollbar-track {
  background: orange;
} */
/*
::-webkit-scrollbar {
  height: 12px;
  width: 12px;
  background: #000;
}

::-webkit-scrollbar-thumb {
  background: #393812;
  -webkit-border-radius: 1ex;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
}

::-webkit-scrollbar-corner {
  background: #000;
} */

::-webkit-scrollbar {
  /* Height adjusts as the page grows longer */
  height: auto;
  width: 10px;
}
::-webkit-scrollbar-track {
  /* Makes track a dark grey but opaque */
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-corner {
  background: #000;
}

::-webkit-scrollbar-thumb {
  /* Grabber is white, rounded, with a slight shadow */
  background: white;
  -webkit-border-radius: 1ex;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
}
</style>
<!-- 

     /* The top layer shadow */ 0 1px 1px rgba(0, 0, 0, 0.15),
    /* The second layer */ 0 10px 0 -5px #eee,
    /* The second layer shadow */ 0 10px 1px -4px rgba(0, 0, 0, 0.15),
    /* The third layer */ 0 20px 0 -10px #eee,
    /* The third layer shadow */ 0 20px 1px -9px rgba(0, 0, 0, 0.15) !important;
 -->
